import { ASSETS } from '../data/content';

const ORIGIN = 'https://crestia.gr';
const ORGANIZATION_ID = `${ORIGIN}/#organization`;

// Public URLs from the sitemap. This copy is metadata only, not visible page copy.
const PAGES = {
  '/': {
    title: 'CRESTIA | Επιχειρηματική συμβουλευτική & ανάπτυξη',
    description: 'Η CRESTIA βοηθά επιχειρήσεις να αυξήσουν τις πωλήσεις τους, να οργανώσουν τη λειτουργία τους και να αξιοποιήσουν πρακτικά το AI. Από τη στρατηγική στην εφαρμογή.',
  },
  '/services': {
    title: 'Υπηρεσίες επιχειρηματικής ανάπτυξης | CRESTIA',
    description: 'Γνωρίστε τους έξι άξονες υπηρεσιών της CRESTIA: στρατηγική, εξαγωγές, βελτίωση λειτουργιών, AI, επιχειρηματική πληροφόρηση και εμπορική ανάπτυξη.',
  },
  '/who-we-serve': {
    title: 'Σε ποιους απευθυνόμαστε | CRESTIA',
    description: 'Δείτε πώς η CRESTIA υποστηρίζει μικρές, μικρομεσαίες, εμπορικές, παραγωγικές και εξαγωγικές επιχειρήσεις στην οργάνωση και την ανάπτυξή τους.',
  },
  '/approach': {
    title: 'Μεθοδολογία: από την ανάλυση στην εφαρμογή | CRESTIA',
    description: 'Η μεθοδολογία της CRESTIA σε έξι βήματα: ανάλυση, στρατηγική, σχεδιασμός, εφαρμογή, μέτρηση και βελτίωση, με βάση την πραγματικότητα κάθε επιχείρησης.',
  },
  '/insights': {
    title: 'Άρθρα για επιχειρήσεις, ανάπτυξη και AI | CRESTIA',
    description: 'Διαβάστε πρακτικά άρθρα της CRESTIA για τις πωλήσεις, τις εξαγωγές, την αξιοποίηση του AI και τη μετατροπή της επιχειρηματικής στρατηγικής σε εφαρμογή.',
  },
  '/contact': {
    title: 'Επικοινωνία | CRESTIA',
    description: 'Επικοινωνήστε με την CRESTIA για μια πρώτη συζήτηση χωρίς δέσμευση. Περιγράψτε την επιχείρησή σας και όσα θέλετε να βελτιώσετε ή να πετύχετε.',
  },
  '/privacy-policy': {
    title: 'Πολιτική Απορρήτου | CRESTIA',
    description: 'Ενημερωθείτε για την επεξεργασία προσωπικών δεδομένων στον ιστότοπο της CRESTIA, τους σκοπούς, τις νομικές βάσεις και τα δικαιώματά σας.',
  },
  '/terms': {
    title: 'Όροι Χρήσης | CRESTIA',
    description: 'Διαβάστε τους όρους χρήσης του ιστοτόπου της CRESTIA και τις πληροφορίες για το περιεχόμενο, την πνευματική ιδιοκτησία και τη χρήση των υπηρεσιών του.',
  },
  '/cookies': {
    title: 'Πολιτική Cookies | CRESTIA',
    description: 'Μάθετε πώς χρησιμοποιούνται τα cookies στον ιστότοπο της CRESTIA, πότε ενεργοποιείται το Google Analytics και πώς διαχειρίζεστε τη συγκατάθεσή σας.',
  },
  '/insights/systima-poliseon-mikri-epixeirisi': {
    title: 'Σύστημα πωλήσεων για μικρές επιχειρήσεις | CRESTIA',
    description: 'Πώς μια μικρή επιχείρηση οργανώνει τις πωλήσεις της με απλό σύστημα, ώστε να εξαρτάται λιγότερο από τυχαίες ευκαιρίες και την προσωπική προσπάθεια του ιδιοκτήτη.',
  },
  '/insights/eksagwges-pente-vimata-nea-agora': {
    title: 'Εξαγωγές: πέντε βήματα πριν από μια νέα αγορά | CRESTIA',
    description: 'Πέντε βήματα προετοιμασίας πριν από την είσοδο σε μια νέα αγορά: πώς μια επιχείρηση προσεγγίζει τις εξαγωγές με σωστή στόχευση και οργανωμένο σχεδιασμό.',
  },
  '/insights/ai-stin-epixeirisi-pragmatiki-aksia': {
    title: 'AI στην επιχείρηση: πού έχει πραγματική αξία | CRESTIA',
    description: 'Πού έχει πρακτική αξία το AI στην επιχείρηση και πού όχι. Η σημασία της σωστής διαδικασίας για την εξοικονόμηση χρόνου και τη βελτίωση αποφάσεων.',
  },
  '/insights/stratigiki-se-efarmogi': {
    title: 'Από τη στρατηγική στην εφαρμογή | CRESTIA',
    description: 'Γιατί τα στρατηγικά πλάνα μένουν στα χαρτιά και πώς μεταφράζονται σε καθημερινές ενέργειες, σαφείς ρόλους και δείκτες που παρακολουθούνται.',
  },
};

function normalizePath(path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return null;
  return path.split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';
}

function organization() {
  return { '@type': 'Organization', '@id': ORGANIZATION_ID, name: 'CRESTIA', url: `${ORIGIN}/`, logo: `${ORIGIN}${ASSETS.logo}` };
}

function structuredData(nodes) {
  return { '@context': 'https://schema.org', '@graph': nodes };
}

export function getRouteSeo(pathname) {
  const path = normalizePath(pathname);
  const page = PAGES[path];
  if (!page) return { title: 'CRESTIA', description: PAGES['/'].description, canonical: null, structuredData: null };
  const nodes = [organization()];
  if (path === '/') nodes.push({ '@type': 'WebSite', '@id': `${ORIGIN}/#website`, name: 'CRESTIA', url: `${ORIGIN}/`, inLanguage: 'el', publisher: { '@id': ORGANIZATION_ID } });
  return { ...page, canonical: `${ORIGIN}${path}`, structuredData: structuredData(nodes) };
}

function publishedDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(value)) return null;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value.slice(0, 10)) return null;
  return value;
}

function publicImage(value) {
  if (typeof value !== 'string' || !value) return null;
  try {
    const url = new URL(value, ORIGIN);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch { return null; }
}

export function getArticleSeo(article) {
  const path = `/insights/${encodeURIComponent(article.slug)}`;
  const known = PAGES[path];
  const title = known?.title || article.meta_title || `${article.title} | CRESTIA`;
  const description = known?.description || article.meta_description || article.excerpt;
  const canonical = `${ORIGIN}${path}`;
  const node = {
    '@type': 'Article', '@id': `${canonical}#article`, headline: article.title,
    description, url: canonical, mainEntityOfPage: canonical, inLanguage: 'el',
    author: { '@id': ORGANIZATION_ID }, publisher: { '@id': ORGANIZATION_ID },
  };
  const date = publishedDate(article.date);
  const image = publicImage(article.image);
  if (date) node.datePublished = date;
  if (image) node.image = image;
  const breadcrumbs = {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Αρχική', item: `${ORIGIN}/` },
      { '@type': 'ListItem', position: 2, name: 'Άρθρα', item: `${ORIGIN}/insights` },
      { '@type': 'ListItem', position: 3, name: article.title, item: canonical },
    ],
  };
  return { title, description, canonical, structuredData: structuredData([organization(), node, breadcrumbs]) };
}

export function serializeJsonLd(data) {
  return JSON.stringify(data).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

function singleton(selector, tag, attributes) {
  const [existing, ...duplicates] = document.head.querySelectorAll(selector);
  duplicates.forEach(node => node.remove());
  const element = existing || document.createElement(tag);
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
  if (!existing) document.head.appendChild(element);
  return element;
}

// Head-only updates. No visible DOM, navigation, storage or analytics side effects.
export function applySeo(seo) {
  document.title = seo.title;
  singleton('meta[name="description"]', 'meta', { name: 'description', content: seo.description });
  if (seo.canonical) singleton('link[rel="canonical"]', 'link', { rel: 'canonical', href: seo.canonical });
  else document.head.querySelectorAll('link[rel="canonical"]').forEach(node => node.remove());
  if (seo.structuredData) {
    const script = singleton('#crestia-seo-jsonld', 'script', { id: 'crestia-seo-jsonld', type: 'application/ld+json' });
    script.textContent = serializeJsonLd(seo.structuredData);
  } else document.getElementById('crestia-seo-jsonld')?.remove();
}
